import React, { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { CreatePendencyFormValues } from '../..'
import { ActionsPendency } from 'common/enum/actions-pendency'
import CardInputMessage from '../../CardInputMessage'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import TextAreaNew from 'presentation/shared/components/TextAreaNew'
import CardMessagePreview from '../../CardMessagePreview'
import RMarkdown from 'presentation/hospital/components/RMarkdown'
import { ReactComponent as DoubleArrowIcon } from 'presentation/assets/icons/double-arrow.svg'
import * as S from '../styles'

type PendencyTabProps = {
  title: string
  // handleCheckboxChange?: (event: ChangeEvent<HTMLInputElement>) => void
  // isOptionChecked?: (doc: string) => boolean
}

const PendencyPersonalized = ({ title }: PendencyTabProps) => {
  const { values, isValid, handleChange, setFieldValue, errors } =
    useFormikContext<CreatePendencyFormValues>()

  const personalizedDivergencesValue =
    values.action === ActionsPendency.CRMO_CREATED_PENDENCY_PERSONALIZED &&
    values.OPTION_PERSONALIZED_TEXT
      ? `${values.OPTION_PERSONALIZED_TEXT}  \n`
      : ''

  const messageBody = [`${personalizedDivergencesValue}`]

  const rawMessageText = messageBody.join('\n\n')

  useEffect(() => {
    setFieldValue('general_observations', rawMessageText)
  }, [values.OPTION_PERSONALIZED_TEXT])

  return (
    <S.TabBoxWrapper isValid={isValid}>
      <CardInputMessage
        title={title}
        isTextArea
        isError={!!errors.OPTION_PERSONALIZED_TEXT}
      >
        <TextAreaNew
          fontSize="xsmall"
          name="OPTION_PERSONALIZED_TEXT"
          placeholder="Digite o texto da pendência"
          scrolling="auto"
          value={values.OPTION_PERSONALIZED_TEXT}
          onChange={handleChange}
          // error={
          //   errors.OPTION_PERSONALIZED_TEXT
          //     ? errors.OPTION_PERSONALIZED_TEXT
          //     : undefined
          // }
        />
      </CardInputMessage>
      {errors.OPTION_PERSONALIZED_TEXT && (
        <S.PersonalizedTextError>
          {errors.OPTION_PERSONALIZED_TEXT}
        </S.PersonalizedTextError>
      )}
      <DoubleArrowIcon className="double-arrow-icon" width={48} height={48} />
      <CardMessagePreview>
        {values.OPTION_PERSONALIZED_TEXT &&
        values.OPTION_PERSONALIZED_TEXT?.length > 0 ? (
          <RMarkdown rawText={rawMessageText} />
        ) : (
          <SupportTextNew color="neutral600" size="xsmall">
            Digite o texto da pendência ao lado para visualizar a prévia da
            mensagem que será enviada
          </SupportTextNew>
        )}
      </CardMessagePreview>
    </S.TabBoxWrapper>
  )
}

export default PendencyPersonalized
